import { StocksRecord } from '@/types';

export function escapeCSV(value: string | number | null | undefined): string {
  const str = String(value ?? '');
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function buildPortfolioCSV(stocks: StocksRecord): string {
  const headers = [
    'Symbol', 'Name', 'Exchange', 'Shares', 'Purchase Price',
    'Purchase Date', 'Currency', 'Current Price', 'Current Value',
    'Gain/Loss', 'Gain/Loss %',
  ];

  const rows: string[] = [headers.join(',')];

  for (const stock of Object.values(stocks)) {
    if (stock.watchlist) continue;

    for (const lot of stock.lots) {
      const currentPrice = stock.currentPrice ?? 0;
      const currentValue = lot.shares * currentPrice;
      const cost = lot.shares * lot.price;
      const gainLoss = currentValue - cost;
      const gainLossPercent = cost !== 0 ? (gainLoss / cost) * 100 : 0;

      rows.push([
        escapeCSV(stock.symbol),
        escapeCSV(stock.name),
        escapeCSV(stock.exchange),
        escapeCSV(lot.shares),
        escapeCSV(lot.price),
        escapeCSV(lot.purchasedDate ?? ''),
        escapeCSV(lot.currency),
        escapeCSV(currentPrice),
        escapeCSV(Number(currentValue.toFixed(2))),
        escapeCSV(Number(gainLoss.toFixed(2))),
        escapeCSV(Number(gainLossPercent.toFixed(2))),
      ].join(','));
    }
  }

  return rows.join('\n');
}

export function exportPortfolioToCSV(stocks: StocksRecord): void {
  const csv = buildPortfolioCSV(stocks);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const date = new Date().toISOString().slice(0, 10);

  const link = document.createElement('a');
  link.href = url;
  link.download = `equitylabs-portfolio-${date}.csv`;
  link.click();

  URL.revokeObjectURL(url);
}
